import moment from 'moment';

export default function DateFormat(props) {
  const date = props.date;
  const format = props.inFormat;

  return <> {date && moment.utc(date).format(format).toUpperCase()}</>;
}
